import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import styles from "./ModuleRegistration.module.css";
import clockImg from "../../../assets/images/clock.png";
import usb from "../../../assets/images/usbMonitor.png";
import { SubmitButton, TextComponent } from "../../../components";
import { TbDeviceRemote, TbScan } from "react-icons/tb";
import stepOne from "../../../assets/images/stepOne.png";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";

const ModuleRegistration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = Storage.getERole("@role");

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          {role == roles.user && (
            <img src={stepOne} className={styles.stepImg} />
          )}

          <TbDeviceRemote className={styles.remoteIcon} />
          <TextComponent
            text={"Module Registration"}
            className={styles.heading}
          />
          <div className={styles.btnDiv}>
            <div className={styles.btn} onClick={() => navigate("/scanQR")}>
              <TbScan size={20} style={{ marginRight: "5px" }} />
              <TextComponent text={"Scan Qr Code"} className={styles.btnText} />
            </div>
            <div
              className={styles.btn}
              onClick={() =>
                navigate("/scanQR", {
                  state: "usb inject",
                })
              }
            >
              <img
                src={usb}
                style={{
                  width: "20px",
                  height: "20px",
                  objectFit: "contain",
                  marginRight: "5px",
                }}
              />
              <TextComponent text={"Plugin USB"} className={styles.btnText} />
            </div>
          </div>
          {!role  && (
            <SubmitButton
              title={"Skip"}
              secondaryBtn
              onClick={() => navigate(-1)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModuleRegistration;
